import { setupClipboard } from '../../../../components/clipboard'

/* eslint-disable vue/return-in-computed-property */

up.compiler('.js-steady_login_settings_app_wrapper', async function (wrapper) {
  const { createVueApp } = await import(/* webpackChunkName: "create_vue_app" */ '../../../../create_vue_app')
  const el = wrapper.querySelector('.js-steady_login_settings_app')
  const language = el.dataset.locale
  const app = createVueApp({
    data: () => ({
      language,
      size: 'medium'
    }),
    computed: {
      buttonText() {
        return this.i18n.$gettext('Log in with Steady')
      },
      buttonStyles() {
        switch (this.size) {
          case 'small':
            return { height: '32px', padding: '8px 12px', 'min-width': '171px' }
          case 'medium':
            return { height: '40px', padding: '10px 14px', 'min-width': '188px' }
          case 'large':
            return { height: '48px', padding: '12px 20px', 'min-width': '219px' }
        }
      },
      imageStyles() {
        switch (this.size) {
          case 'small':
            return { width: '11px' }
          case 'medium':
            return { width: '12px' }
          case 'large':
            return { width: '13px' }
        }
      },
      separatorStyles() {
        switch (this.size) {
          case 'small':
            return { 'margin-right': '8px', 'margin-left': '8px' }
          case 'medium':
            return { 'margin-right': '10px', 'margin-left': '10px' }
          case 'large':
            return { 'margin-right': '14px', 'margin-left': '14px' }
        }
      }
    },
    mounted: async function () {
      const element = document.querySelector('[data-clipboard-target]')
      this.clipboardDestructor = await setupClipboard(element)
    },
    beforeUnmount: function () {
      this.clipboardDestructor()
    }
  })

  app.mount(el)

  up.destructor(wrapper, () => {
    app.unmount()
  })
})
